import { useEffect } from 'react';

/**
 * Settings > Setup > Bailey's welcome (staging only).
 *
 * Nothing to show: it sends the owner to their diary with ?intro=1, which
 * plays the welcome from the top without touching setup afterwards.
 */
export default function BaileyWelcomeReplay({ history }) {
  useEffect(() => {
    const salonId = localStorage.getItem('salonId') || '';
    history.replace(`/diary/${salonId}?intro=1`);
  }, [history]);
  return null;
}
